'use strict';

/**
 * Component for length
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../../templates/components/detail/field-length.hbs');

var LegnthComponent = ItemView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        lengthValue: function() {
            return this.getText();
        },
    },

    getText: function() {
        var field = this.getOption('field');

        return this.model.getTextValue(field.name);
    },

    hasValue: function() {
        var field = this.getOption('field');

        return this.model.get(field.name) ? true : false;
    },
});

module.exports = LegnthComponent;